"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Services = _interopRequireDefault(require("../../Services"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Box5 = function Box5(props) {
  return _react.default.createElement("div", {
    className: "sl-box5"
  }, _react.default.createElement("div", {
    className: "sl-loader",
    style: {
      "--size": _Services.default.getZoom(props.size || 100)
    }
  }, _react.default.createElement("div", {
    className: "sl-loader-items"
  }, _react.default.createElement("div", {
    className: "sl-rectangular-ping",
    style: {
      "--bgb": props.bgColor || "#FFFFFF",
      "--bg": _Services.default.rgbToPart(props.bgColor, "50") || "#FFFFFF50"
    }
  }))), props.title !== undefined ? _react.default.createElement("div", {
    className: "sl-loader-title",
    style: {
      "--cl": props.color || "#FFFFFF"
    }
  }, _react.default.createElement("span", null, props.title)) : null);
};

var _default = Box5;
exports.default = _default;